import { getChatBase, getAccessToken } from '../../AiAssistant/chatApiBase'
import { buildExportParams, ChatSearchParams, ChatSearchResponse, ChatSessionDetail } from './chatSearchModel'

export async function searchChats(params: ChatSearchParams): Promise<ChatSearchResponse> {
  const token = getAccessToken()
  const query = new URLSearchParams()

  if (params.sessionId) {
    query.set('session_id', params.sessionId)
  }
  if (params.userName) {
    query.set('user_name', params.userName)
  }
  if (params.q) {
    query.set('q', params.q)
  }
  if (params.from) {
    query.set('from', params.from)
  }
  if (params.to) {
    query.set('to', params.to)
  }
  if (params.tenantGuid) {
    query.set('tenant_guid', params.tenantGuid)
  }
  if (params.myChats) {
    query.set('my_chats', 'true')
  }
  query.set('page', String(params.page))
  query.set('page_size', String(params.pageSize))

  const res = await fetch(`${getChatBase()}/search?${query}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  })
  if (!res.ok) {
    throw new Error(`Chat search failed: ${res.status}`)
  }
  return res.json()
}

export async function exportChats(params: ChatSearchParams): Promise<Blob> {
  const token = getAccessToken()
  const query = buildExportParams(params)
  const res = await fetch(`${getChatBase()}/search/export?${query}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  })
  if (!res.ok) {
    throw new Error(`Chat export failed: ${res.status}`)
  }
  return res.blob()
}

export async function getChatSession(sessionId: string): Promise<ChatSessionDetail> {
  const token = getAccessToken()
  const res = await fetch(`${getChatBase()}/search/${sessionId}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  })
  if (!res.ok) {
    throw new Error(`Chat session fetch failed: ${res.status}`)
  }
  return res.json()
}
